export interface LocationState {
  country?: { id: string; name: string };
  city?: { id: string; name: string };
  district?: { id: string; name: string };
}

export interface PickupFormData {
  forClientId: string;
  locationName: string;
  countryId: string;
  cityId: string;
  districtId: string;
  fullAddress: string;
  shortAddress: string;
  pinCode: string;
  latitude: string;
  longitude: string;
}

export interface Address {
  name: string;
  email: string;
  mobile: string;
  country: string;
  city: string;
  district: string;
  zipCode: string;
  latitude: string;
  longitude: string;
  address: string;
  nationalAddress: string;
  countryName?: string;
  cityName?: string;
  districtName?: string;
  streetName?: string;
  buildingName?: string;
  buildingNumber?: string;
  dialCode?: string;
  shortAddress?: string;
}

export interface ShipmentDetails {
  referenceNumber?: string;
  paymentType: string;
  numberOfPieces: string;
  totalWeight: string;
  serviceType?: string;
  shipmentType?: string;
  description?: string;
  shipmentCost?: string;
  codAmount?: string;
}

export interface OrderFormData {
  clientId?: string;
  clientName?: string;
  darkstoreId?: string;
  branchDarkstoreId?: string;
  sender: Address;
  receiver: Address;
  shipment?: ShipmentDetails;
  products?: {
    pId: string;
    quantity: string;
    weight: number;
  }[];
}

export type AddressOption = "short" | "manual" | "map";

export interface ShortAddress {
  shortAddress: string;
  nationalAddress: {
    buildingNumber: string;
    street: string;
    secondaryNumber?: string;
    district: string;
    postalCode: string;
    city: string;
  };
  location?: {
    latitude: number;
    longitude: number;
    googleMapsLink?: string;
  };
  buildingNumber?: string;
  street?: string;
  secondaryNumber?: string;
  district?: string;
  postalCode?: string;
  city?: string;
  latitude?: number;
  longitude?: number;
  googleMapsLink?: string;
}

// Constants
export const SHIPMENT_SERVICE_OPTIONS = [
  {
    id: "EXPRESS_24_HR",
    value: "Express (24 Hr Delivery)",
    text: "Express (24 Hr Delivery)",
  },
  { id: "SAME_DAY", value: "Same Day Delivery", text: "Same Day Delivery" },
  { id: "NEXT_DAY", value: "Next Day Delivery", text: "Next Day Delivery" },
  { id: "ECONOMY", value: "Economy", text: "Economy" },
  { id: "INTERNATIONAL", value: "International", text: "International" },
];

export const ORDER_SHIPMENT_TYPE_OPTIONS = [
  { id: "PARCEL", value: "PARCEL", text: "PARCEL" },
];

export const PAYMENT_TYPE_OPTIONS = [
  { id: "CC", value: "CC", text: "CC" },
  { id: "COD", value: "COD", text: "COD" },
];

export const LABEL_SIZE_OPTIONS = [
  //   { id: "A4", value: "A4", text: "A4 (210mm x 297mm)" },
  //   { id: "A5", value: "A5", text: "A5 (148mm x 210mm)" },
  //   { id: "A6", value: "A6", text: "A6 (105mm x 148mm)" },
  { id: "4X6", value: "4X6", text: "4 x 6 inches" },
  //   { id: "100X150", value: "100X150", text: "100 x 150mm" },
];
